<template>
  <div>
    <TypificationTreeNode
      v-for="node in treeData"
      :key="node.key"
      :node="node"
      :expandedKeys="expandedKeys"
      :selectedKeys="selectedKeys"
      :checkedKeys="checkedKeys"
      @update-checked="handleCheckedUpdate"
      @update-selected="handleSelectedUpdate"
      @update-expanded="handleExpandedUpdate"
    />
  </div>
</template>

<script lang="ts" setup>
import { ref, defineProps, defineEmits } from 'vue';
import TypificationTreeNode from '@/app/strategies/components/modals/typificationSelected/TypificationTreeNode.vue';

interface TreeNodeProps {
  title: string;
  key: string;
  children?: TreeNodeProps[];
  class?: string;
  pattern?: string;
}

const props = withDefaults(
  defineProps<{
    expandedKeys: string[];
    selectedKeys: string[];
    checkedKeys: string[];
    treeData: TreeNodeProps[];
    childrensData: TreeNodeProps[];
  }>(),
  {
    selectedKeys: [],
  }
);

const emit = defineEmits<{
  (e: 'update:expandedKeys', value: string[]): void;
  (e: 'update:selectedKeys', value: string[]): void;
  (e: 'update:checkedKeys', value: string[]): void;
}>();

const updateCheckedKeys = (key: string, checked: boolean) => {
  const newCheckedKeys = new Set(props.checkedKeys);
  if (checked) {
    newCheckedKeys.add(key);
  } else {
    newCheckedKeys.delete(key);
    props.childrensData.forEach((item) => {
      if (item.pattern == key) {
        newCheckedKeys.delete(item.key);
      }
    });

  }
  emit('update:checkedKeys', Array.from(newCheckedKeys));
};

const updateSelectedKeys = (key: string) => {
  emit('update:selectedKeys', [key]);
};

const updateExpandedKeys = (key: string) => {
  const newExpandedKeys = new Set(props.expandedKeys);
  if (newExpandedKeys.has(key)) {
    newExpandedKeys.delete(key);
  } else {
    newExpandedKeys.add(key);
  }
  emit('update:expandedKeys', Array.from(newExpandedKeys));
};

const handleCheckedUpdate = (key: string, checked: boolean) => {
  updateCheckedKeys(key, checked);
};

const handleSelectedUpdate = (key: string) => {
  updateSelectedKeys(key);
};

const handleExpandedUpdate = (key: string) => {
  updateExpandedKeys(key);
};
</script>
